module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.working) ? _c('b-jumbotron', {
    attrs: {
      "header": "Sign in using Steam",
      "lead": "slotlist.info uses Steam OpenID authentication. This allows you to use your existing Steam account to log into our site."
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n      The site will not be able to read or store your Steam login credentials or perform any action regarding your Steam account.\n      "), _c('br'), _vm._v(" We will only receive your SteamID as well as some other public information such as your username.\n      "), _c('br'), _vm._v(" The information provided by Steam will be used to create a unique user in our backend for you, allowing you to use all features on\n      "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("slotlist.info")]), _vm._v(".\n      "), _c('br'), _vm._v(" More information regarding the privacy policy of this site can be found\n      "), _c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("here")]), _vm._v(".\n    ")], 1), _vm._v(" "), (_vm.loginRedirectUrl) ? _c('p', {
    staticClass: "lead text-center"
  }, [_c('a', {
    attrs: {
      "href": _vm.loginRedirectUrl
    }
  }, [_c('img', {
    attrs: {
      "src": "https://steamcommunity-a.akamaihd.net/public/images/signinthroughsteam/sits_01.png",
      "alt": "Sign in through Steam",
      "title": "Yes, this login banner looks atrocious, unfortunately Valve forces us to use it >.< Anyways, click to sign in through Steam"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Frequently Asked Questions regarding the Steam login")]), _vm._v(" "), _c('p', [_vm._v("taken from the FAQ on our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Home")]), _vm._v(" page\n      ")], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-justify"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("How does the login work?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_vm._v("I am still sceptical or confused...")]), _vm._v(" "), _c('p', [_vm._v("\n        We would be happy to talk to you, explaining our service in more detail and trying to clear up any confusion as best as we can - just contact us via any method mentioned on our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" page. Whilst we obviously would like to have you as a user of our service, we can also understand scepticism and value any sort of feedback highly.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("Can you access my Steam account after I log in to your website?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("What information do you store about me?")]), _vm._v(" "), _c('p', [_vm._v("\n        When you log in for the first time, our backend creates a new user in our database, storing the SteamID provided by Steam's login service as well as your (public) Steam nickname at that point. You can change your nickname on this website at any point by going to your\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account")]), _vm._v(" page while logged in. Please note that changing your Steam nickname will not update your nickname on\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" since we do not query Steam for your nickname after the initial login anymore. Beside your SteamID and nickname, the stored user information contains a unique user ID that is randomly generated by our backend and used to uniquely identify your user throughout the app."), _c('br'), _vm._v("When you register for a mission slot, a database entry containing the slot ID, your user ID and the optional comment - if provided - is created."), _c('br'), _vm._v("If you would like to receive a dump of all information currently stored about you, please contact us via any method mentioned on the\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" page and we will be happy to provide you with any data we have."), _c('br'), _vm._v("More information regarding the privacy policy of this website can be found\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("here")]), _vm._v(".\n      ")], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        We are utilising a login service provided by Steam, called\n        "), _c('em', [_vm._v("Steam OpenID")]), _vm._v(" or\n        "), _c('em', [_vm._v("Steam Single Sign On")]), _vm._v(". You can find more information about this service\n        "), _c('a', {
    attrs: {
      "href": "https://steamcommunity.com/dev"
    }
  }, [_vm._v("here")]), _vm._v("."), _c('br'), _vm._v("When you click the\n        "), _c('em', [_vm._v("Sign in through Steam")]), _vm._v(" button, you will be redirected to a Steam community page where you will be asked to log in to your Steam account. Please note that we have no access at all to this page and do not receive your Steam credentials. The whole login process is handled securely by Steam on the\n        "), _c('code', [_vm._v("steamcommunity.com")]), _vm._v(" domain.\n        "), _c('strong', [_vm._v("You will never have to enter your Steam credentials on our website or any other non-Steam service.")]), _c('br'), _vm._v("Once you have successfully completed your login, Steam will redirect you back to our website and provide us with information required to identify you as a user of our service."), _c('br'), _vm._v("The data provided by Steam's login service is limited to your SteamID as well as your nickname, both of which are also publicly visible to everyone on Steam.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("No, absolutely not.")]), _vm._v(" As previously mentioned, we do not handle any login at all, but use a service provided by Steam to all developers. All authentication is handled by Steam itself - we only receive an \"assurance\" you actually are who you claim to be.\n        "), _c('strong', [_vm._v("The information we receive does not grant us any access to your Steam account, Steam library or any credentials associated.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e53d1c6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Login.en.vue
// module id = 571
// module chunks = 0